<template>
    <v-layout wrap row>
     <v-icon
        v-if="!hideDragIcon"
        class="reorder-icon d-block mr-2"
        color="secondary"
        style="position:absolute; margin-top:20px; margin-left:-37px;cursor:grab">
        swap_vert
      </v-icon>
       <v-expansion-panel class="on-white-bg child-expansion thin-border-bottom hideExpansion elevation-0 py-0 px-0 rounded-3 mb-0" style="position:relative;" :value="isOpen">
          <v-expansion-panel-content>
            <div slot="header">
              <v-layout wrap>
                 <v-flex xs12 lg5 :style="$vuetify.breakpoint.mdAndDown && 'width: calc(100% - 90px)!important; display:inline-block; float:left; flex-basis:initial !important'">
                  <span class="opacity-54" style="display:block; font-family:roboto, sans-serif !important;">Task</span>
                  <h3 style="position:relative;" class="text-truncate">{{task.description}}</h3>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex
                  xs12 lg7 class="mr-0 mt-0 text-xs-right"
                  :style="$vuetify.breakpoint.mdAndDown && 'width:90px !important; display:inline-block; flex-basis:initial !important'"
                  style="height:42px;">
                  <div class="hidden-md-and-down" style="display:inline-block">
                    <h4 class="d-inline-block ma-2 mr-4"  style="font-family:roboto, sans-serif !important; vertical-align:middle">
                      <span class="opacity-54" style="display:block; font-family:roboto, sans-serif !important;">{{updatedAt}}</span>
                    </h4>
                  </div>
                </v-flex>
              </v-layout>
            </div>
            <v-container ma-0 px-0 pb-4 pt-2 row fluid wrap>
              <v-flex xs12 md6 mt-0>
                <v-text-field
                  box label="Task name"
                  class="white-box-field"
                  v-model="task.description">
                </v-text-field>
                <v-textarea
                  box label="Guidance notes"
                  class="white-box-field"
                  v-model="task.guidance">
                </v-textarea>
                <v-select
                  box dense
                  v-model="task.actionType"
                  class="white-box-field"
                  v-bind:items="taskTypes"
                  item-text="name"
                  item-value="value"
                  label="Task Action"
                  append-icon="keyboard_arrow_down">
                </v-select>
                <v-textarea
                  box
                  label="Enter your expressive statement here"
                  class="white-box-field"
                  v-model="task.actionDefinition"
                  v-if="task.actionType === 'ModifyCaseActionTask'">
                </v-textarea>
                <v-textarea
                  box
                  label="Enter your expressive statement here"
                  class="white-box-field"
                  v-model="task.actionDefinition"
                  v-if="task.actionType === 'WebHookActionTask'">
                </v-textarea>
                <v-text-field
                  box
                  v-if="task.actionType === 'PostUrlActionTask'"
                  label="Enter the URL to submit here"
                  class="white-box-field"
                  v-model="task.actionDefinition">
                </v-text-field>
                <v-flex class="mb-4" v-if="task.actionType === 'JavascriptActionTask'">
                  <v-select
                    box dense
                    class="white-box-field"
                    v-bind:items="functions"
                    item-text="name"
                    label="Pick a function"
                    v-model="func"
                    append-icon="keyboard_arrow_down">
                  </v-select>
                  <!-- <h3>Parameters</h3>
                  <v-divider></v-divider>
                  <v-flex v-for="(param, index) in params" :key="index">
                    <v-text-field
                      box label="Name"
                      v-model="param.name"
                      class="white-box-field">
                    </v-text-field>
                    <v-textarea
                      box label="Description"
                      v-model="param.description"
                      hint="Enter a prompt that will be shown to the user"
                      class="white-box-field">
                    </v-textarea>
                    <v-select
                      box dense
                      class="white-box-field"
                      v-model="param.parameterType"
                      v-bind:items="['Template', 'Text', 'Selection']"
                      item-text="name"
                      label="Pick a function"
                      append-icon="keyboard_arrow_down">
                    </v-select>
                    <v-switch color="secondary" style="margin-top:-12px" v-model="param.required">
                      <template v-slot:label>
                        Required parameter
                        <v-tooltip top color="secondary">
                          <v-icon style="vertical-align:middle" color="secondary" class="ml-2" slot="activator">
                            help
                          </v-icon>
                          <span>Text explaining this toggle</span>
                        </v-tooltip>
                      </template>
                    </v-switch>
                    <v-btn @click="removeParameter(param)" class="mt-0 ml-0" color="error">Delete Parameter</v-btn>
                    <v-divider ma-2></v-divider>
                  </v-flex>
                  <v-btn class="ml-0 mt-2" color="secondary" @click="addParameter()">Add a parameter</v-btn> -->
                </v-flex>
                <v-flex class="mb-4">
                  <h3>Task Button</h3>
                  <v-divider></v-divider>
                  <v-select
                    box dense clearable
                    class="white-box-field"
                    v-model="task.fieldset"
                    v-bind:items="fieldsets"
                    item-text="name"
                    label="Fieldset"
                    append-icon="keyboard_arrow_down">
                  </v-select>
                </v-flex>
              </v-flex>
              <v-flex xs12 sm6>
                <v-layout row>
                  <v-btn @click="deleteDialog = true" class="mt-0 ml-0" color="error">Delete Task</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn @click="updateTask()" class="mt-0 mr-0" color="success">Update Task</v-btn>
                </v-layout>
              </v-flex>
           </v-container>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <delete-dialog :isOpen="deleteDialog" itemType="task" v-on:delete-item="removeTask"></delete-dialog>
    </v-layout>

</template>

<script>
import { mapState } from "vuex"
import Helpers from "@/helpers.js"
import DeleteDialog from "@/components/shared/deleteDialog"

export default {
  name: "sortable-task",
  props: ["taskTemplate", "tasklistId", "position", "caseType", "scripts"],
  components: { DeleteDialog },
  data: () => ({
    taskTypes: [
      { name: "Manual", value: "ManuaTask" },
      { name: "Delete Case", value: "DeleteCaseActionTask" },
      { name: "Javascript", value: "JavascriptActionTask" }
    ],
    data: '',
    newParam: false,
    isOpen: null,
    deleteDialog: false
  }),
  computed: {
    ...mapState({
      hideDragIcon: state => state.ui.hideDragIcons,
      preferences: state => state.currentUser.me.preferences
    }),
    task() { if (this.taskTemplate) { return this.taskTemplate } else { return undefined } },
    func: {
      get() {
        if (this.taskTemplate && this.taskTemplate.actionDefinition) {
          try {
            const defn = JSON.parse(this.taskTemplate.actionDefinition)
            if (defn) {
              return defn.taskPath
            }
          } catch (error) {
            // do nothing
          }
        }
        return undefined
      },
      set(script) {
        this.taskTemplate.actionDefinition = JSON.stringify({ taskPath: script })
      }
    },
    params() {
      if (this.tasks && this.tasks.parameters) { return this.tasklistTemplate.parameters } else { return [] }
    },
    updatedAt() {
      if (this.task && this.task.updatedAt && this.preferences && this.preferences.dateTimeForm) {
        return Helpers.formatDate(this.task.updatedAt, this.preferences.dateTimeFormat)
      } else { return undefined }
    },
    functions() {
      if (this.caseType && this.scripts.length > 0) {
        const functions = []
        const casetypeName = this.caseType.displayName
        this.scripts.forEach(function(script) { functions.push(casetypeName + '/' + script.name) })
        return functions
      } else {
        return []
      }
    },
    fieldsets() {
      if (this.caseType && this.caseType.currentSchema && this.caseType.currentSchema.fieldsets) {
        const fieldsets = this.caseType.currentSchema.fieldsets
        return (fieldsets && Array.isArray(fieldsets)) ? fieldsets.map(fieldset => fieldset.name) : []
      }
      return []
    }
  },
  watch: {
    position(newValue) {
      this.task.position = this.position
      const updateTask = {
        tasklist_id: this.tasklistId,
        id: this.task.id,
        description: this.task.description,
        guidance: this.task.guidance,
        position: this.position,
        actionType: this.task.actionType,
        actionDefinition: this.task.actionDefinition,
        key: this.task.key
      }
      this.$store.dispatch("updateTaskTemplate", updateTask)
    }
  },
  methods: {
    removeTask(shouldDelete) {
      this.deleteDialog = false
      if (shouldDelete) {
        this.isOpen = null
        this.$emit('task-remove', this.task.id)
      }
    },
    updateTask() {
      this.isOpen = null
      const self = this

      this.params.forEach(function(param) {
        self.updateParameter(param)
      })
      const updateTask = {
        tasklist_id: this.tasklistId,
        id: this.task.id,
        description: this.task.description,
        guidance: this.task.guidance,
        position: this.position,
        actionType: this.task.actionType,
        actionDefinition: this.task.actionDefinition,
        key: this.task.key,
        fieldset: (this.task.fieldset) ? this.task.fieldset : null
      }
      if (!updateTask.actionDefinition) { updateTask.actionDefinition = " " }
      this.$store.dispatch('updateTaskTemplate', updateTask)
    },
    async addParameter() {
      const newParam = {
        taskTemplateId: this.task.id,
        name: "",
        parameterType: "",
        required: false
      }
      const response = await this.$store.dispatch('createTaskTemplateParameter', newParam)
      if (!response.error) {
        newParam.id = response.id
        this.params.push(newParam)
      }
    },
    updateParameter(param) {
      const updateParam = {
        id: param.id,
        name: param.name,
        description: param.description,
        parameterType: param.parameterType,
        required: param.required,
        parameterData: param.parameterData
      }
      this.$store.dispatch('updateTaskTemplateParameter', updateParam)
    },
    async removeParameter(param) {
      const response = await this.$store.dispatch('deleteTaskTemplateParameter', param.id)
      if (!response.error) {
        const index = this.params.indexOf(param)
        this.params.splice(index, 1)
      }
    },
    cancel() {
      this.isOpen = null
      this.data = this.task
    }
  }
}
</script>
